import { cn } from '@/lib/utils';
import { LogoMark } from './logo-mark';

interface LogoProps extends React.HTMLAttributes<HTMLSpanElement> {
  /** Visually hidden label override (defaults to "HumAIne"). */
  label?: string;
}

/* Full horizontal logo: brand mark icon + "HumAIne" wordmark.
 * The mark is an inline SVG so it renders crisply at any size.
 * The wordmark uses CSS font utilities so it inherits the loaded web fonts.
 */
export function Logo({ className, label = 'HumAIne', ...props }: LogoProps) {
  return (
    <span
      className={cn('inline-flex items-center gap-2', className)}
      aria-label={label}
      translate="no"
      {...props}
    >
      <LogoMark size={28} aria-hidden="true" />
      <span
        aria-hidden="true"
        className="inline-flex items-baseline font-display text-2xl font-bold leading-none tracking-tight"
      >
        <span className="text-fg">Hum</span>
        <span className="text-gradient-brand">AI</span>
        <span className="text-fg">ne</span>
      </span>
    </span>
  );
}
